export const defaultTheme = {
    mode: localStorage.getItem('mode') || window.matchMedia("(prefers-color-scheme: dark)").matches ? 'dark' : 'light' as 'dark' | 'light',
    mobile: 750,
    laptop: 1000,
    light: {
        mainBackground: '#f8fbff',
        secondaryBackground: '#f5f5f5',
        navbar: '#05090E',
        note: '#e7e7e7',
        border: '#dee2e6',
        title: '#040d19',
        mainMenu:{
            header: '#040d19',
            item: '#040d19',
            hover: '#dee2e6'
        },
        link: {
            hover: '#bdbdbd'
        },
        highLight: '#d7d7d7'
    },
    dark: {
        mainBackground: '#040d19',
        secondaryBackground: '#061222',
        navbar: '#05090E',
        note: '#0c1a2c',
        border: '#323840',
        title: '#adb6bf',
        mainMenu:{
            header: '#424548',
            item: '#adb6bf',
            hover: '#111b28'
        },
        link: {
            hover: '#50637c'
        },
        highLight: '#222222'
    }
};